module.exports = __webpack_public_path__ + "img/paytype-center.c357ac27.png";